module.exports = __webpack_public_path__ + "assets/img/11_851_big.26e236de.jpg";